<template>
  <div
    class="menu-item"
    @mouseover.prevent.stop="itemOver($event)"
    @mouseout.prevent.stop="itemOut($event)"
  >
    <a
      v-if="item.smartUrl"
      :href="item.smartUrl"
      @click.prevent.stop="itemClicked()"
      class="link accentColour"
      v-html="item.label"
    />
    <Flex v-else column w-full>
      <Flex
        w-full
        py-2
        px-5
        justify-between
        @click.prevent.stop="itemClicked()"
        ref="menuChildrenItem"
      >
        <Icon v-if="item.children" src="bwise/open-sidepane" size="sm" class="menuitem-icon" />
        <Flex label v-html="item.label" />
        <Icon
          class="self-center text-gray-500"
          v-if="item.cssClass === 'userPinned'"
          src="bwise/close"
          size="sm"
          v-on:click.stop="removeShortcut(item)"
          v-tooltip.top="'Remove'"
        />
      </Flex>
    </Flex>
  </div>
</template>

<script>
import Flex from '@wizer/core/components/flex/Flex.vue'
import Icon from '@wizer/core/components/icon/Icon'
import events from '@wizer/core/events'
import EHSLegacyService from '@/services/EHSLegacyService'
import MenuItemMixin from '@/mixins/MenuItemMixin'

export default {
  name: 'MenuChildrenItem',

  mixins: [MenuItemMixin],

  components: {
    Flex,
    Icon,
  },

  props: {
    item: {},
  },

  methods: {
    async removeShortcut(item) {
      if (item.pinnedItemId) {
        events.confirm(
          async () => {
            const shortcuts = (await EHSLegacyService.unpinShortcut(item.pinnedItemId)).data
              .updatedFavourites
            this.$emit('shortcutRemoved', { shortcuts })
          },
          this.$t('wrapper.confirmMessage'),
          {
            header: this.$t('wrapper.confirm'),
            confirmText: this.$t('Button.OK'),
            cancelText: this.$t('Button.Cancel'),
          },
        )
      }
    },
  },
}
</script>

<style scoped lang="postcss">
.menu-item {
  @apply w-full cursor-pointer;
  min-height: 2.5rem;
}
.menu-item:not(.accentColour),
.menu-item:not(.accentColour) .link.accentColour {
  @apply text-gray-700;
}
.link {
  @apply block w-full;
  padding: 0.6rem 1.25rem;
}
.menu-item.active,
.menu-item:hover {
  @apply bg-gray-200;
}
.menuitem-icon {
  @apply absolute right-0 pr-4 pt-1 text-gray-500;
}
.label {
  @apply w-11/12;
  padding: 0.1rem 0;
}
</style>
